import type {DashboardAccessLevel,DashboardPermission} from './types';

/** The four roles, widest first. Supabase enforces them; this module only describes them. */
export const LEVEL_ORDER:DashboardAccessLevel[]=['super_admin','admin','manager','client'];

export const ACCESS_LEVELS:Record<DashboardAccessLevel,{label:string;summary:string;tone:string}>={
 super_admin:{label:'Super admin',summary:'Every agency and every client, private tracking, and appointing admins and other super admins.',tone:'violet'},
 admin:{label:'Admin',summary:'One marketing agency: its clients, websites, leads and reports. Adds managers and clients.',tone:'indigo'},
 manager:{label:'Manager',summary:'Only the clients they manage, in the client portal. Adds client logins for those clients.',tone:'cyan'},
 client:{label:'Client',summary:'Only their own business: leads, calls, outcomes and lead alerts.',tone:'slate'},
};

/** Default sections per role; mirrors private.dashboard_permission_defaults in Supabase. */
export const LEVEL_DEFAULTS:Record<DashboardAccessLevel,DashboardPermission[]>={
 super_admin:['analytics','reports','testing','websites','leads','explorer','paid_media','drainscapes','integration_health','team_access','tracking','services','clients','agencies'],
 admin:['analytics','reports','testing','websites','leads','explorer','paid_media','drainscapes','integration_health','team_access','services','clients'],
 manager:['portal'],
 client:['portal'],
};

/** Managers and clients use the client portal; staff use the dashboard. */
export const isPortalLevel=(level:string|null|undefined)=>level==='manager'||level==='client';

export function levelLabel(level:string|null|undefined):string{
 if(!level)return 'Member';
 return ACCESS_LEVELS[level as DashboardAccessLevel]?.label??level.replaceAll('_',' ');
}
